module.exports = __webpack_public_path__ + "img/user.e44fdddc.svg";